// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__y-WFJ","right":"styles_right__3KkXe"};